import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

const mapStateToProps = (state, ownProps) => {
  return {
    activeClass: state.app.menuTopIndex === ownProps.id ? "active" : ""
  };
};

class MenuTopItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { label, activeClass, path } = this.props;

    return (
      <NavLink to={`${path}`}>
        <div className={`p-menu-main-nav-menu-item ${activeClass}`}>{label}</div>
      </NavLink>
    );
  }
}

export default connect(
  mapStateToProps,
  null
)(MenuTopItem);



// WEBPACK FOOTER //
// src/components/menu/MenuTopItem.js